import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

const Meter = ({ label, value, percent, color }) => (
  <Box mb={3}>
    <Flex justify="space-between" wrap="wrap" gap={2} fontSize="sm" mb={1}>
      <Text fontWeight="semibold">{label}</Text>
      <Text color="gray.600">{value}</Text>
    </Flex>
    <Box h="14px" bg="gray.100" borderRadius="full" overflow="hidden">
      <Box
        h="100%"
        w={`${Math.max(0, Math.min(100, percent))}%`}
        bg={color}
        borderRadius="full"
        transition="width 0.4s"
      />
    </Box>
  </Box>
);

const SEAT_COLORS = {
  red: 'red.400',
  yellow: 'yellow.400',
  green: 'green.500',
};

/**
 * Barre di avanzamento dei posti e del numero minimo di partecipanti.
 * `seats` è opzionale (assente per eventi con varianti o a link esterno).
 */
const EventRegistrationMeters = ({
  seats,
  minimumRequired,
  currentParticipants,
}) => {
  const hasMinimum = minimumRequired != null;
  const reached = currentParticipants >= minimumRequired;
  const needed = Math.max(0, minimumRequired - currentParticipants);

  return (
    <Box color="gray.800" minW={0}>
      {seats ? (
        <>
          <Meter
            label="Posti disponibili"
            value={`${seats.available} su ${seats.capacity}`}
            percent={
              ((seats.capacity - seats.available) / seats.capacity) * 100
            }
            color={SEAT_COLORS[seats.color] || 'green.500'}
          />
          {seats.phrase ? (
            <Text fontSize="sm" color="gray.500" mt={-1} mb={3}>
              {seats.phrase}
            </Text>
          ) : null}
        </>
      ) : null}
      {hasMinimum ? (
        <>
          <Meter
            label="Minimo per partire"
            value={`${currentParticipants} / ${minimumRequired} iscritti`}
            percent={(currentParticipants / minimumRequired) * 100}
            color={reached ? 'green.500' : 'orange.400'}
          />
          <Box
            fontSize="sm"
            px={3}
            py={2}
            borderRadius="md"
            borderLeft="4px solid"
            borderColor={reached ? 'green.500' : 'orange.400'}
            bg={reached ? 'green.50' : 'orange.50'}
            color={reached ? 'green.800' : 'orange.800'}
          >
            {reached
              ? `✓ Questo evento partirà! Minimo di ${minimumRequired} partecipanti raggiunto.`
              : `Parte con almeno ${minimumRequired} partecipanti: ${
                  needed === 1
                    ? 'manca ancora 1 persona'
                    : `ne mancano ancora ${needed}`
                }. Se l’evento non dovesse partire, ti rimborseremo automaticamente.`}
          </Box>
        </>
      ) : null}
    </Box>
  );
};

export default EventRegistrationMeters;
